export class Amenagement {
    id: number;
    name: string;
}


